import { MatchVideoDetail as MatchVideoDetailComponent } from './MatchVideoDetail.component';
import { connector } from './MatchVideoDetail.connector';

export const MatchVideoDetail = connector(MatchVideoDetailComponent);
